<template>
  <div class="results-container v-card" :style="{ borderLeft: `6px solid ${getStatusLabel(status).color}` }">
    <div class="campaign-header">
      <div class="campaign-info">
        <h1 class="campaign-title">
          <span> {{ campaign.title }} </span>
        </h1>
        <span class="campaign-description"> {{ campaign.description }} </span>
        <div class="campaign-status">
          <mf-icon fill small :color="getStatusLabel(status).color">fiber_manual_record</mf-icon><span>{{ getStatusLabel(status).text }}</span>
        </div>
      </div>
      <!-- <div v-if="showSettingsButton" class="d-flex">
        <mf-button label="Ver configurações do disparo" outlined text-transform="none" class="offer-settings-button" @click="emitSettingsFunction" />
      </div> -->
    </div>

    <div class="campaign-body mt-8">
      <div class="campaign-info-cards">
        <div v-for="card in cardsItems" :key="card.key" class="info-card">
          <info-card :title="card.title" :description="card.value" :tooltip="card.tooltip" :card-key="card.key">
            <template v-if="card.key === 'target'" slot="additional-content">
              <div v-if="campaign.segments && campaign.segments.length">
                <v-chip-group :column="showAllSegments" show-arrows active-class="primary--text">
                  <v-chip v-for="(segment, index) in campaign.segments" :key="index" color="white" small :ripple="false" @click="goToSegmentation(index)">
                    <span v-if="segment">
                      <b>{{ segment.name }}</b>
                      {{ segment.clients_qty !== null ? ` (${localeString(segment.clients_qty, 0)} clientes)` : '' }}
                    </span>
                  </v-chip>
                </v-chip-group>
                <a v-if="campaign.segments.length > 1" class="user-select-none mt-3 mb-0 body-2" @click="showAllSegments = !showAllSegments">{{
                  showAllSegments ? 'Minimizar' : 'Mostrar todos'
                }}</a>
              </div>
              <div v-else class="no-segments-text">
                <span>{{ 'Não segmentada' }}</span>
              </div>
              <clients-distribution-bar :clientsDistribution="clientsDistribution" />
            </template>
          </info-card>
        </div>
      </div>

      <div class="campaign-lists">
        <chip-list
          variant="units"
          details-type="dialog"
          title="Lojas participantes:"
          dialog-title="Lojas participantes"
          :items="campaignUnits"
          :units="unitsList"
          use-default-headers
        />
        <chip-list
          variant="products"
          details-type="dialog"
          title="Produtos:"
          dialog-title="Produtos"
          :items="campaignProducts"
          :products="campaignProductsWithImage"
          use-default-headers
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { getStatusLabel } from '@/config/helpers.js'
import InfoCard from '@/components/campaigns/InfoCard.vue'
import ChipList from '@/components/ChipList.vue'
import ClientsDistributionBar from './ClientsDistributionBar.vue'

export default {
  name: 'ResultsHeader',
  components: {
    InfoCard,
    ChipList,
    ClientsDistributionBar,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    showSettingsButton: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    showAllSegments: false,
  }),
  computed: {
    status() {
      return this.campaign?.status?.toUpperCase()
    },
    validityPeriodInitialDate() {
      return DateTime.fromFormat(this.campaign?.initial_date?.toString(), 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
    },
    validityPeriodFinalDate() {
      return DateTime.fromFormat(this.campaign?.final_date?.toString(), 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
    },
    cardsItems() {
      return [
        {
          key: 'validity-period',
          title: 'Período de mensuração',
          value: `${this.validityPeriodInitialDate} - ${this.validityPeriodFinalDate}`,
          tooltip: '',
        },
        {
          key: 'target',
          title: 'Público alvo',
          value: '',
          tooltip: '',
        },
      ]
    },
    clientsDistribution() {
      return this.campaign.client_targets_distribution
    },
    unitsList() {
      return this.campaign.units.map((unit) => {
        return { unit: unit.name }
      })
    },
    campaignProducts() {
      return this.campaign.unique_products.map((product) => `${product.sku} - ${product.name}`)
    },
    campaignProductsWithImage() {
      return this.campaign.unique_products.map((product) => {
        return { name: product.name, image: product?.image, sku: product.sku }
      })
    },
    campaignUnits() {
      return this.campaign.units.map((unit) => unit.name)
    },
  },
  methods: {
    getStatusLabel,
    emitSettingsFunction() {
      const route = this.$router.resolve({ name: 'edit-maria-campaign', params: { id: this.campaign._id } })
      window.open(route.href, '_blank')
    },
    goToSegmentation(index) {
      if (!this.campaign.has_segment_data) {
        this.$snackbar({ message: 'Não é possível visualizar critérios desta campanha', snackbarColor: 'error' })
        return
      }
      const segment = this.campaign.segments[index]
      if (!segment) return
      const routeData = this.$router.resolve({
        name: 'visualizar-segmentacao',
        params: {
          campaignId: this.campaign._id,
          segmentId: segment._id,
        },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style scoped lang="scss">
.results-container {
  border-radius: 4px;
  background: white;
  padding: 20px 24px !important;
  .campaign-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .campaign-info {
      display: flex;
      flex-direction: column;
      gap: 6px;
      .campaign-title {
        color: $cinza-d10;
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0.01em;
      }
      .campaign-description {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: $cinza-0;
      }
      .campaign-status {
        display: flex;
        flex-direction: row;
        gap: 2px;
        align-items: center;
        span {
          color: $cinza-d10;
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
        }
      }
    }
  }
  .campaign-body {
    display: flex;
    flex-direction: row;
    gap: 40px;
    .campaign-info-cards {
      width: 40%;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
    .campaign-lists {
      width: 60%;
      display: flex;
      flex-direction: column;
      gap: 40px;
    }
  }
}
.no-segments-text {
  span {
    color: $cinza-d10;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
  }
}
::v-deep .offer-settings-button {
  .v-btn__content {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.01em;
    text-align: center;
  }
}
</style>
